export default function locationToUrl(to) {
    const buffer = [
        to.pathname
    ];
    const searchString = stringifySearch(to.search);
    const hashString = to.hash;
    if (searchString) {
        buffer.push(`?${searchString}`);
    }
    if (hashString) {
        buffer.push(`#${hashString}`);
    }
    return buffer.join('');
}
function stringifySearch(search) {
    const buffer = [];
    if (search) {
        objectToString(buffer, [], search);
    }
    return buffer.join('&');
}
function valueToString(buffer, path, value) {
    if (value instanceof Array) {
        arrayToString(buffer, path, value);
    } else if (value && typeof value === 'object') {
        return objectToString(buffer, path, value);
    } else if (value != null) {
        stringToString(buffer, path, `${value}`);
    }
}
function objectToString(buffer, path, object) {
    for(const name in object){
        if (object.hasOwnProperty(name)) {
            valueToString(buffer, path.concat(name), object[name]);
        }
    }
}
function arrayToString(buffer, path, array) {
    array.forEach((value, i)=>{
        valueToString(buffer, path.concat(`${i}`), value);
    });
}
function stringToString(buffer, path, value) {
    const rest = path.map((p)=>encodeURIComponent(p));
    const base = rest.shift();
    const encodedKey = `${base}${rest.length ? `[${rest.join('][')}]` : ''}`;
    const encodedValue = encodeURIComponent(value == null ? '' : `${value}`);
    buffer.push(`${encodedKey}=${encodedValue}`);
}

//# sourceMappingURL=locationToUrl.js.map